import { render, staticRenderFns } from "./RegionLayerEditor.vue?vue&type=template&id=5301a53e&scoped=true"
import script from "./RegionLayerEditor.vue?vue&type=script&lang=js"
export * from "./RegionLayerEditor.vue?vue&type=script&lang=js"
import style0 from "./RegionLayerEditor.vue?vue&type=style&index=0&id=5301a53e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5301a53e",
  null
  
)

export default component.exports